var _style, _text, _text2, _rect, _text3, _text4, _rect2, _text5, _text6, _rect3, _text7, _text8, _rect4, _text9, _text0, _rect5, _text1, _text10, _rect6, _text11, _text12, _rect7, _text13, _text14, _rect8, _text15, _text16, _rect9, _text17, _text18, _rect0, _text19, _text20, _rect1, _text21, _text22, _rect10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpacingCenter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 550",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    .label-key { font-family: -apple-system, sans-serif; font-size: 14px; fill: #64748b; font-weight: 400; }\r\n    .label-val { font-family: -apple-system, sans-serif; font-size: 14px; fill: #94a3b8; font-weight: 400; }\r\n    .blue-bar { fill: #0284c7; rx: 4px; }\r\n  ")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 35,
    className: "label-key"
  }, "space-4")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 35,
    className: "label-val"
  }, "4px (0.25rem)")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 22,
    width: 6,
    height: 16,
    className: "blue-bar"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 75,
    className: "label-key"
  }, "space-8")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 75,
    className: "label-val"
  }, "8px (0.5rem)")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 62,
    width: 10,
    height: 16,
    className: "blue-bar"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 115,
    className: "label-key"
  }, "space-12")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 115,
    className: "label-val"
  }, "12px (0.75rem)")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 102,
    width: 14,
    height: 16,
    className: "blue-bar"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 155,
    className: "label-key"
  }, "space-16")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 155,
    className: "label-val"
  }, "16px (1rem)")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 142,
    width: 18,
    height: 16,
    className: "blue-bar"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 195,
    className: "label-key"
  }, "space-24")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 195,
    className: "label-val"
  }, "24px (1.5rem)")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 182,
    width: 26,
    height: 16,
    className: "blue-bar"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 235,
    className: "label-key"
  }, "space-32")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 235,
    className: "label-val"
  }, "32px (2rem)")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 222,
    width: 34,
    height: 16,
    className: "blue-bar"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 275,
    className: "label-key"
  }, "space-40")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 275,
    className: "label-val"
  }, "40px (2.5rem)")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 262,
    width: 44,
    height: 16,
    className: "blue-bar"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 315,
    className: "label-key"
  }, "space-48")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 315,
    className: "label-val"
  }, "48px (3rem)")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 302,
    width: 52,
    height: 16,
    className: "blue-bar"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 355,
    className: "label-key"
  }, "space-64")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 355,
    className: "label-val"
  }, "64px (4rem)")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 342,
    width: 68,
    height: 16,
    className: "blue-bar"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 395,
    className: "label-key"
  }, "space-80")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 395,
    className: "label-val"
  }, "80px (5rem)")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 382,
    width: 86,
    height: 16,
    className: "blue-bar"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 435,
    className: "label-key"
  }, "space-96")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 435,
    className: "label-val"
  }, "96px (6rem)")), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 422,
    width: 102,
    height: 16,
    className: "blue-bar"
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 475,
    className: "label-key"
  }, "space-120")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 475,
    className: "label-val"
  }, "120px (7.5rem)")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 462,
    width: 130,
    height: 16,
    className: "blue-bar"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpacingCenter);
export default __webpack_public_path__ + "static/media/spacing-center.351b4cee7ebbd4a0c55b16fb5b2d4ed3.svg";
export { ForwardRef as ReactComponent };